/*
 * @Author: Chao Yang
 * @Date: 2020-09-08 15:18:13
 * @LastEditor: Chao Yang
 * @LastEditTime: 2020-12-08 12:42:43
 */
import { Injectable } from '@angular/core';
import { BaseProxy } from '../base.proxy';
import { Observable } from 'rxjs';
import * as Onboarding from 'src/app/domain/model/offering';

@Injectable()
export class OnboardingProxy extends BaseProxy {
  getFundListByMarketingFundId(
    fundId: number
  ): Observable<Onboarding.IMarketingFund> {
    return this._http.get<Onboarding.IMarketingFund>(
      `/ip/api/fund/${fundId}/onboarding/list`
    );
  }

  checkAccountNameUnique(
    onboardingFundId: number,
    name: string
  ): Observable<boolean> {
    return this._http.get<boolean>(
      `/ip/api/fund/onboarding/${onboardingFundId}?name=${encodeURIComponent(
        name
      )}`
    );
  }

  subscribeToOnboarding(
    onboardingFundId: number,
    name: string
  ): Observable<Onboarding.ISubscribeResult> {
    return this._http.post<Onboarding.ISubscribeResult>(
      `/ip/api/fund/onboarding/${onboardingFundId}?name=${encodeURIComponent(
        name
      )}`,
      undefined
    );
  }
}
